import React, { useEffect } from 'react';
import { ActionFunctionAny } from 'redux-actions';
import { Action } from 'typesafe-actions';

import * as Types from 'types';
import { GridTitle } from 'components/artworksGrid/GridTitle';
import { ArtworksGridContainer } from 'components/artworksGrid/Container';

type StateProps = {
  listings: Types.Listing[];
};

type DispatchProps = {
  changeCurrentListing: ActionFunctionAny<Action<any>>;
};

type OwnProps = {};

type Props = OwnProps & DispatchProps & StateProps;

export const NftGrid: React.FC<Props> = ({ listings, changeCurrentListing }) => {
  useEffect(() => {
    if (listings) {
      const nftListing = listings.find((l) => l.title === 'NFTs')?.id;

      nftListing && changeCurrentListing({ id: nftListing });
    }
  }, [listings]);

  return (
    <div className='container mt-3 mb-2 nft-grid'>
      <div className='js-artwork-grid'>
        <GridTitle
          linkText={'Browse more'}
          content={'NFT Artworks'}
          url={`${Routes.artworks_path()}?nft=true`}
        />
        <ArtworksGridContainer type='curated' />
      </div>
    </div>
  );
};
